import { useEffect, useMemo, useState } from 'react';
import { buildTaskChargeInvoices, isInvoiceableTask, resolveTaskBillTo } from '../../../utils/taskInvoice';

// Invoices for a task's posted charges, built on the fly from the task and its charges.
const useTaskChargeInvoices = (task, enabled = true, companySellerName = '') => {
    const chargeCount = task?.postCharges?.length || 0;
    const hasCharges = Boolean(enabled && task && isInvoiceableTask(task) && chargeCount > 0);
    const companyId = task?.companyId;
    const sellerId = task?.sellerId;
    const [billTo, setBillTo] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!hasCharges) return undefined;
        let active = true;
        setLoading(true);
        resolveTaskBillTo({ companyId, sellerId }, companySellerName).then((result) => {
            if (!active) return;
            setBillTo(result);
            setLoading(false);
        });
        return () => {
            active = false;
        };
    }, [hasCharges, companyId, sellerId, companySellerName]);

    const invoices = useMemo(
        () => (hasCharges ? buildTaskChargeInvoices(task, billTo || {}) : []),
        [hasCharges, task, billTo]
    );

    return { invoices, loading };
};

export default useTaskChargeInvoices;
